import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=6db29f04"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDialog,VImg})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db29f04')) {
      api.createRecord('6db29f04', component.options)
    } else {
      api.reload('6db29f04', component.options)
    }
    module.hot.accept("./WelcomeDialog.vue?vue&type=template&id=6db29f04", function () {
      api.rerender('6db29f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Login/WelcomeDialog.vue"
export default component.exports